import { render, staticRenderFns } from "./LetterIcon.vue?vue&type=template&id=400c42ed&"
import script from "./LetterIcon.vue?vue&type=script&lang=ts&"
export * from "./LetterIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports